<template>
    <div class="item-row">
        <ul class="item-row">
            <ItemHeadBox :title=tile.name />
            <div v-for="service in tile.services" :key="service.id">
                <ItemBox :service=service />
            </div>
        </ul>
    </div>
</template>

<script>
    import ItemBox from './ItemBox'
    import ItemHeadBox from './ItemHeadBox'
    export default {
        components: { ItemBox, ItemHeadBox},
        props: {
            tile: {
                name: '',
                services: {
                    name: '',
                    latestData: {
                        value: '',
                        time: ''
                    }
                }
            }
        }
    }
    // <ItemBox :service=service />


    // 
    //     <li> sd </li>
    // </ul>

</script>



// WEBPACK FOOTER //
// src/components/ItemRow.vue